var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSourcingThemeLevelThree = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  d: "M11.995 5.106 10.378 3.49a.535.535 0 0 0-.756 0L8.005 5.106m7.222 3.232 1.616 1.617a.535.535 0 0 1 0 .756l-1.616 1.617m-3.232 3.232-1.617 1.616a.535.535 0 0 1-.756 0L8.005 15.56m-3.232-3.232L3.157 10.71a.535.535 0 0 1 0-.756l1.616-1.617m2.536 1.996L10 7.642l2.692 2.692L10 13.026z"
})));
export default SvgSourcingThemeLevelThree;